import { Img } from "./logoStyle";
import { useNavigate } from "react-router-dom";

const Logo = () => {
  const navigate = useNavigate();

  return (
    <Img
      src={"https://sli.lbca.com.br/wp-content/uploads/2023/11/lbca-logo.png"}
      alt="Logo LBCA"
      onClick={() => navigate(-1)}
    />
  );
};

export default Logo;
